module.exports = __webpack_public_path__ + "img/house.2c67e2bf.png";